import { useState, useEffect, ForwardedRef, useImperativeHandle, forwardRef } from 'react';
import { referalUrl, referraledUrl } from '../../constants';
import styled from './index.module.scss';
import Input from '@/components/UI/Input';
// import Checkbox from '@/components/UI/Checkbox';
import Button from '@/components/UI/Button';
import NextImage from '@/components/NextImage';
import { useReferralStore, useReferralDispatch } from '@/components/Ambassador/ReferralProvider';
import { FaceBookIcon, TwitterIcon } from '@/components/UI/svg/Referral';
import EfModal from '@/components/UI/Modal';
import { useGlobal } from '@/utils/useGlobal';
import { getIsLogin, loginUser } from '@/utils/cookie';
import { message } from '@/components/UI/Message';
import { sendInviteEmail } from '@/service/referral';
import { copyText } from '@/components/Ambassador/util';
import { signupCookie } from '@/utils/cookies/signupCookie';

export type ReferHandle = {
    show: () => void;
};

interface ReferPorps {
    isShare?: boolean;
}

const reg = /^[A-Za-z\d]+([.%~`$^*&(){}<>?"+=!_\\-]*[A-Za-z\d-])*@[a-zA-Z\d-]{1,30}\.[a-zA-Z\d.%#~`$^*&(){}<>?"+=!_\\-]{1,30}$/;
const Refer = ({ isShare = true }: ReferPorps, ref: ForwardedRef<ReferHandle>) => {
    const { useLang, isMobile, useRouter, Link } = useGlobal();
    const router = useRouter();
    const { locale, asPath } = useRouter();
    const { t } = useLang('referral');
    const { t: sharedT } = useLang('shared');
    const [show, setShow] = useState(false);
    const { shareInfo, referralInfo } = useReferralStore();
    const dispatch = useReferralDispatch();
    const [copyValue, setCopyValue] = useState('');
    const [sendEmail, setSendEmail] = useState('');
    // const [checked, setChecked] = useState(false);
    const isLogin = getIsLogin();

    const referralPath = referalUrl[locale] || referalUrl.us;
    const sharePath = referraledUrl[locale] || referraledUrl.us;
    // 分享文案
    const shareText = {
        faceBook: `${t('refer.share_text')}\n${copyValue}`,
        twitter: `${t('refer.share_text')}\n${copyValue}`,
    };

    const handleShare = () => {
        if (!isLogin) {
            signupCookie?.({
                sector_name: t('refer.title'),
                entry_position: 6,
            });
            location.href = `/${locale}/login?redirect=${encodeURIComponent(`/${locale}/${asPath}?pop=share`)}`;
            return;
        }

        if (!isShare) {
            router.push(referralPath);
            return;
        }
        dispatch({
            type: 'getShareInfo',
            payload: {
                data: {
                    planId: referralInfo?.planId,
                    shareUrl: `${location.origin}/${locale}/${sharePath}`,
                },
                locale,
            },
        });
        setShow(true);
    };

    const handleSendMsg = () => {
        if (!referralInfo || !shareInfo) return;
        const { email } = loginUser().user;
        // 如果与用户邮箱相同提示
        if (email && email === sendEmail.trim()) return message.error(t('refer.thesameemail'));
        sendInviteEmail(
            {
                planId: referralInfo?.planId,
                shareEmail: sendEmail.trim(),
                shareId: shareInfo?.shareId,
                shareUrl: copyValue,
            },
            locale,
        )
            .then((res) => {
                if (res.code !== '0') return message.error(res.message);
                message.success(sharedT('my.site_account_profile_save_success'));
                setSendEmail('');
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        if (!shareInfo) return;
        const path = 'referral-rewards';
        setCopyValue(`${location.origin}/${locale}/${path}?inviteCode=${shareInfo?.inviteCode}`);
    }, [shareInfo]);

    useImperativeHandle(ref, () => ({
        show: () => handleShare(),
    }));

    if (!referralInfo) return <></>;

    return (
        <div className={styled.refer}>
            <div className="refer_center">
                <NextImage src={require(`@publicLocal/referral/${isMobile ? 'h5' : 'pc'}/share.jpg`)} alt={t('refer.title')} aria-label={t('refer.title')} />
                <div className="text_box">
                    <h3 className="title">{t('refer.title')}</h3>
                    <p className="desc">{t('refer.desc')}</p>
                    <Button className="refer-btn" onClick={handleShare}>
                        {isLogin && t('refer.btn1') ? t('refer.btn1') : t('refer.btn')}
                    </Button>
                </div>
            </div>
            <EfModal width={560} visible={show} open={show} className={`${styled.refer_modal}`} onCancel={() => setShow(false)} centered>
                <div className={styled.refer_modal}>
                    <h5 className="title">{t('refer.pop_title1')}</h5>
                    <div className="copy_content">
                        <Input value={copyValue} disabled />
                        <Button className="refer_modal_btn" onClick={() => copyText(copyValue, sharedT)}>
                            {t('refer.pop_btn1')}
                        </Button>
                    </div>
                    <h5 className="title">{t('refer.pop_title2')}</h5>
                    <Input value={sendEmail} onChange={(e: any) => setSendEmail(e.target.value)} placeholder={t('refer.pop_inputplaceholder')} />
                    <div className="send_email">
                        <Button className="refer_modal_btn" onClick={handleSendMsg} disabled={!reg.test(sendEmail)}>
                            {t('refer.pop_btn2')}
                        </Button>
                    </div>
                    <p className="line">{t('refer.other')}</p>
                    <div className="tools_icon">
                        <Link href={`https://www.facebook.com/sharer/sharer.php?u=${copyValue}`} target="_blank">
                            <FaceBookIcon />
                        </Link>
                        <Link href={`https://twitter.com/intent/tweet?text=${shareText.twitter}`} target="_blank">
                            <TwitterIcon />
                        </Link>
                    </div>
                </div>
            </EfModal>
        </div>
    );
};

export default forwardRef<ReferHandle, ReferPorps>(Refer);
